import {Trans} from "react-i18next";
import {css, Interpolation, Theme} from "@emotion/react";
import {flexAlignCenter, mb, pb} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image";
import {Text} from "@pg-design/text";

import {IPGEmployee} from "../../common/app/constants/pg_employees";

type TContactPersonAlign = "center" | "left";

interface IContactPersonProps extends IPGEmployee {
    className?: string;
    /** Emotion styles (np. `mediaBox` z widoku kontaktu). */
    css?: Interpolation<Theme>;
    /** Domyślnie wyśrodkowanie jak na stronie kontaktu. */
    contentAlign?: TContactPersonAlign;
}

export const ContactPerson = ({
    picture,
    name,
    role,
    phone,
    email,
    className,
    css: cssProp,
    contentAlign = "center"
}: IContactPersonProps) => {
    const align = contentAlign === "left" ? "left" : "center";

    return (
        <div css={[cssProp, className, contentAlign === "left" ? personLeft : personCenter]}>
            <Image src={picture} alt={name} width="160" height="160" css={[personImg, mb(4)]} loading="lazy" />

            <div css={pb(3)}>
                <Text variant="body_copy_1" align={align}>
                    {name}
                </Text>

                <Text variant="info_txt_1" align={align}>
                    <Trans>{role}</Trans>
                </Text>
            </div>

            <div>
                <Text variant="body_copy_1" strong align={align}>
                    <a href={`tel:${phone}`}>{phone}</a>
                </Text>
                <Text variant="body_copy_2" align={align}>
                    <a href={`mailto:${email}`}>{email}</a>
                </Text>
            </div>
        </div>
    );
};

const personRoot = css`
    display: flex;
    flex-direction: column;
`;

const personCenter = css`
    ${personRoot};
    align-items: center;
`;

const personLeft = css`
    ${personRoot};
    align-items: flex-start;
`;

const personImg = css`
    border-radius: 50%;
`;
